import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faCircleCheck,
  faHandPointer,
  faLocationCrosshairs,
} from '@fortawesome/free-solid-svg-icons'
import L from 'leaflet'
import MapComponent from '../../../components/map-component/MapComponent'

interface MapSelectorProps {
  position: L.LatLng | null
  setPosition: (pos: L.LatLng | null) => void
  coordinates: L.LatLngExpression
  showMyLocation: boolean
  setLocationFunction: (func: () => void) => void
  mapError: boolean
  t: (key: string) => string
  loading: boolean
}

const MapSelector: React.FC<MapSelectorProps> = ({
  position,
  setPosition,
  coordinates,
  showMyLocation,
  setLocationFunction,
  mapError,
  t,
  loading,
}) => (
  <div className='checkout-page__map-wrap'>
    <div className={`checkout-page__map${mapError ? ' is-error' : ''}`}>
      <MapComponent
        position={position}
        setPosition={setPosition}
        coordinates={coordinates}
        showMyLocation={showMyLocation}
        setLocationFunction={setLocationFunction}
      />
      <div className={`checkout-page__map-hint${position ? ' is-done' : ''}`}>
        <FontAwesomeIcon icon={position ? faCircleCheck : faHandPointer} />{' '}
        {t('SELECT_DELIVERY_LOCATION')}
      </div>
      <button
        className='checkout-page__map-locate'
        disabled={loading}
        onClick={() => setLocationFunction(() => null)}
      >
        <FontAwesomeIcon icon={faLocationCrosshairs} />
        <span>{t('SHOW_MY_LOCATION')}</span>
      </button>
    </div>
    {mapError && <p className='checkout-page__error'>{t('MAP_ERROR')}</p>}
  </div>
)

export default MapSelector
